export default {
  special: {
    Year: 'XX', // 年
    Th: 'XXth', // 号
    '01月': 'Jan ', // 一月
    '02月': 'Feb ', // 二月
    '03月': 'Mar ', // 三月
    '04月': 'Apr ', // 四月
    '05月': 'May ', // 五月
    '06月': 'Jun ', // 六月
    '07月': 'Jul ', // 七月
    '08月': 'Aug ', // 八月
    '09月': 'Sept ', // 九月
    '10月': 'Oct ', // 十月
    '11月': 'Nov', // 十一月
    '12月': 'Dec ', // 十二月
  },
  common: {
    pleaseEnter: 'please enter content',
    passLogin: 'Password Login',
    switchSuccess: 'Switch Success',
    login: 'Login',
    Cancel: 'Cancel', // 取消
    Clear: 'Clear', // 清空
    Search: 'Search', // 搜索
    TurnOn: 'Turn on', // 开启
    Close: 'Close', // 关闭
    Time: 'Time', // 时间
    Download: 'Download', // 下载
    Edit: 'Edit', // 修改
    Delete: 'Delete', // 删除
    Save: 'Save', // 保存
    Agree: 'Agree', // 同意
    Deny: 'Deny', // 拒绝
    Ok: 'Ok', // 确定
    Language: 'Language', // 语言
    Chinese: 'Chinese', // 中文
    English: 'English', // 英文
    Link: 'Link', // 链接
    Year: 'Year', // 年
    PleaseFillAccount: 'Please fill in the account number', // 请填写账号
    Apply: 'Apply ', // 申请
    Permission: ' permission', // 权限
    DateFormat: 'yyyy-MM-dd HH:mm', // yyyy年MM月dd日 HH:mm
    Hour: 'h ', // 小时
    Minute: 'm ', // 分
    Second: 's ', // 秒
    Grant: 'Grant', // 授予
    PermissionsSucc: ' permissions succeeded', // 权限成功
    PermissionsFail: ' permissions failed', // 权限失败
    Upload: 'Upload', // 上传
    Today: 'Today ', // 今天
    Jan: 'Jan', // 一月
    Feb: 'Feb', // 二月
    Mar: 'Mar', // 三月
    Apr: 'Apr', // 四月
    May: 'May', // 五月
    Jun: 'Jun', // 六月
    Jul: 'Jul', // 七月
    Aug: 'Aug', // 八月
    Sept: 'Sept', // 九月
    Oct: 'Oct', // 十月
    Nov: 'Nov', // 十一月
    Dec: 'Dec', // 十二月
    People: 'XX people', // XX人
    Loading: 'Loading', // 加载中
    Next: 'Next', // 下一步
  },
  login: {
    LoginWithPassword: 'Login with password', // 密码登录
    phoneUserEmail: 'Phone number/Username/Mail', // 手机号/用户名/邮箱
    Password: 'Password', // 密码
    LogIn: 'Log in', // 登录
    Registration: 'Free Registration', // 免费注册
    ThirdPartyLogin: 'Third party login', // 第三方登录
    Interconnected: 'the Tlying Eephant Interconnected', // 飞象互联
    AccountNotExist: 'Account does not exist', // 账户不存在
    InvalidPassword: 'Invalid password', // 密码错误
    Second: 's', // 秒
    NetworkNotConnected: 'The network is not connected, please connect and try again', // 网络未连接，请连接后重试
    AccountError: 'Account entry error', // 账号输入错误
    PasswordError: 'Incorrect password', // 密码输入错误
    PhonenumberNotValid: 'please enter a valid phone number', // 请输入正确的手机号
    PasswordLess6Char: 'Password must be at least 6 characters', // 密码至少6位
    PasswordMore18Char: 'Password up to 18 characters', // 密码最多18位
    CheckPrivacyPolicy: 'Please tick the Privacy Policy', // 请勾选隐私协议
    NameMore16Char: 'Name cannot exceed 16 characters', // 姓名不能超过16个字符
    NameLess2Char: 'Name at least 2 characters', // 姓名至少2个字符
    NameNotSpace: 'No spaces at the beginning and end of the name', // 姓名首尾不能有空格
    EnterPhoneNumber: 'Please enter the phone number', // 请输入手机号码
    RegisterSucc: 'Registered successfully', // 注册成功
    PasswordFormat: 'Password can only contain uppercase and lowercase letters, numbers, _, =, @', // 密码只能包含大小写字母、数字、_、=、@
    GetGraphicVerifyFailed: 'Failed to get graphic verification code, please try again', // 获取图形验证码失败，请重试
    ReadAgreed: 'I have read and agreed to the', // 我已阅读并同意
    UserServiceAgreement: 'User Service Agreement', // 用户服务协议
    ServiceAgreement: 'Service Agreement', // 服务协议
    and: 'and', // 和
    PrivacyPolicy: 'Privacy Policy', // 隐私政策
    PrivacyPolicyNo: 'Privacy Policy', // 隐私政策
    version: 'version', // 版本
    AgreementDescription1: 'In order to protect your legitimate rights and interests, please fully read and agree to the update of the ', // 拼接成完整的话
    AgreementDescription2: '.', // 拼接成完整的话
    AgreeContinue: 'Agree and continue', // 同意并继续
    Disagree: 'Disagree', // 不同意
  },
  register: {
    EnterYourPhoneMumber: 'Please enter your phone number', // 请输入手机号
    EnterVerificationCode: 'Please enter the verification code', // 请输入验证码
    GetVerificationCode: 'verification code', // 获取验证码
    VerificationCode: 'Verification Code', // 图形验证码
    EnterVerificationCode1: 'Please enter the verification code', // 请输入图形验证码
    ChangeOne: 'Change', // 换一张
    EnterPassword: 'Please enter your password', // 请输入密码
    ConfirmPassword: 'Please confirm the password again', // 请再次确认密码
    EnterUsername: 'Please enter a username', // 请输入姓名
    MeansAgreeingAgreement: 'Registering means agree to ', // 注册即表示同意HiLeia服务协议
    ServiceAgreement: "HiLeia's service agreement", // 注册即表示同意HiLeia服务协议
    Back: 'Back', // 返回登录
    SignUp: 'Sign up', // 注册
    VerificationCodeNotExist: 'The verification code does not exist or has expired', // 验证码不存在或已过期
    EnterCorrectVerificationCode: 'Please enter correct verification code', // 请输入正确的图形验证码
    Password6Characters: 'Password must be at least 6 characters', // 密码至少6位
    EnterPasswordNotMatch: 'The two entered passwords do not match', // 密码不一致
    Reacquire: 'reacquire', // 后重新获取
  },
  forgot: {
    EnterPhoneNumber: 'Enter PhoneNumber', // 输入手机号码
    ForgotPassword: 'Forgot Password?', // 忘记密码
    SetNewPassword: 'Set New Password', // 设置新密码
    SetPasswordSucc: 'Password set successfully', // 密码设置成功
  },
  home: {
    MoreHowManyCollaborators: 'Max of collaborators', // 协作人数上限
    NotAddTypeOfExist: 'This type already exists and cannot be added', // 已有该类型，无法添加
    AddTypeSucc: 'Type added successfully', // 类型添加成功
    More5Types: 'Select up to 5 types', // 最多选5个类型
    Cooperation: 'Cooperation', // 协作
    Appointment: 'Appointment', // 预约协作
    ScheduleOfAppointmentCollaboration: 'Schedule of Appointment collaboration', // 预约协作日程
    AppointmentNow: 'Appointment now', // 立即预约
    Theme: 'Theme', // 主题
    CollaborationCreatedOf: 'Collaboration created by XX', // XX创建的协作
    StartingTime: 'Starting time', // 开始时间
    PleaseSelectDate: 'Please select a date', // 请选择日期
    EndTime: 'End time', // 结束时间
    Type: 'Type', // 类型
    PleaseClik: 'Please add the type', // 请添加类型
    AddType: 'Add the type', // 添加类型
    EnteType: 'Please enter the type', // 请输入类型
    Collaborator: 'Collaborator', // 协作方
    AddPhoneAndUsername: 'Add by phone number and username', // 通过手机号、用户名添加
    Contacts: 'Contacts', // 联系人
    ContactsSelected: 'XX contacts have been selected', // 已选X个联系人
    Host: 'Host', // 主持人
    MemberJoinMute: 'Member join mute', // 成员入会静音
    Attachment: 'Attachment', // 附件
    UploadAttachment: 'Upload Attachment', // 上传附件
    CancelAppointment: 'Cancel appointment', // 取消预约
    ModifiedContentContinueExit: 'The modified content is not saved, whether to continue to exit', // 修改内容未保存，是否继续退出
    AppointmentSucc: 'Appointment successful', // 预约成功
    AddCalendar: 'Add to Calendar', // 添加到日历
    ViewDetails: 'View details', // 查看详情
    CopyInvitationLink: 'Copy invite link', // 复制邀请链接
    CollaborateNow: 'Collaborate now', // 立即协作
    SearchType: 'Search type', // 搜索类型
    Company: 'Company', // 企业
    SearchCompanies: 'Search for companies', // 查找企业
    QuickCollaboration: 'Quick collaboration', // 快速协作
    ToStart: 'to start', // 等待开始
    InProgress: 'in progress', // 进行中
    Over: 'over', // 已结束
    CollaborationTime: 'Collaboration Time', // 协作时间
    CollaborationType: 'Collaboration Type', // 协作类型
    Edit: 'Edit', // 修改详情
    StartCollaboration: 'Start collaboration', // 开始协作
    CancelCollaboration: 'Cancel collaboration', // 取消协作
    InviteCollaborators: 'Invite collaborators', // 邀请协作方
    JoinCollaboration: 'Join collaboration', // 加入协作
    VideoRecord: 'Video Record', // 视频记录
    NoVideo: 'NO video', // 没有视频
    VideoList: 'Video List', // 视频列表
    CompositeVideo: 'Composite Video', // 合成视频
    Fragment: 'Fragment Of ', // 片段
    Back: 'Back', // 收回
    Files: 'Files', // 相关文件
    NoFiles: 'No files', // 暂无协作文件
    File: 'File', // 文件
    From: 'From ', // 来自
    Time: 'Time', // 时间
    InvitesCommunicateCollaborate: 'XX invites you to communicate and collaborate', // XX邀请你通讯协作
    HangUp: 'Hang Up', // 挂断
    Answer: 'Answer', // 接听
    NoCollaboration: 'No collaboration yet', // 暂无协作
    Accept: 'Accept', // 接受
    ClickAddType: 'Click to add type', // 点击添加类型
    NoCotacts: 'Temporary no cotacts', // 暂无联系人
    NoSearchResut: 'No search content', // 暂无搜索内容
    AddFriend: 'Add friends', // 添加好友
    RequestAdd: 'Request to add', // 请求添加
    PeopleNotHiLeiaAuth: 'This user does not have HiLeia permission and cannot be added', // 此用户暂无HiLeia权限，无法添加
    CompanyNotIntroduce: 'No company introduction yet', // 公司暂未填写介绍
    CompanyNotAddress: 'The company address has not been filled yet', // 公司暂未填写地址
    Me: 'Me', // 我
    Refused: 'Refused', // 已拒绝
    Refused1: 'Refused', // 已被拒绝
    UnknownState: 'Unknown status', // 未知状态
    NotJoinIsFull: 'The number of collaborators is full and cannot join, please contact the inviter', // 协作人数已满，无法加入，请联系邀请人
    More20Char: 'Type max 20 characters', // 类型最多20个字符
    NoNotice: 'No notice yet', // 暂无通知
    AgreedRequest: 'Agreed to your friend request', // 同意了您的好友申请
    DeclinedRequest: 'Declined your friend request', // 拒绝了您的好友申请
    ApplyFriend: 'Apply to add you as a friend', // 申请加您为好友
    AlreadyFriend: 'XX is already your friend', // XX已经是您的好友了
    CancelAccount: 'Cancel account', // 注销账户
    PleaseChoose: 'Please choose', // 请选择
    SetSuccessfully: 'Set up successfully', // 设置成功
    ConfirmChanges: 'Confirm the changes', // 确认修改
    Less6Char: 'Minimum 6 characters', // 最少6个字符
    PasswordNotSame: 'Old and new passwords cannot be the same', // 新旧密码不能相同
    PasswordMustBeSame: 'The two passwords do not match', // 两次密码不一致
    PasswordChangedSucc: 'Password changed successfully, please log in again', // 修改密码成功，请重新登录
    AccountCancelSucc: 'Account cancelled successfully', // 账户注销成功
    VerifySendSucc: 'Verification code sent successfully', // 验证码发送成功
    Cancelled: 'Cancelled', // 已取消
    Undetermined: 'Undetermined', // 未确定
    Confirmed: 'Confirmed', // 已确定
    Solved: 'Solved', // 已解决
    Unsolved: 'Unsolved', // 未解决
    NotJoined: 'Not joined', // 未加入
    InMeeting: 'In meeting', // 在会议中
    LeaveMeeting: 'Leave the meeting', // 离开会议
    ToInitiate: 'To initiate', // 发起
    NoVideoRecord: 'No video record yet', // 暂无视频记录
    NoCollaborationDocs: 'No collaboration documents yet', // 暂无协作文件
    More32Members: 'Up to XX members can communicate and collaborate at the same time', // 最多XX位成员同时通讯协作
    More15ChineseOr30Char: 'You can enter up to 15 Chinese characters or 30 English letters', // 最多可以输入15个汉字字符或者30个英文字母
    Less1Member: 'Please select at least one contact', // 请至少选择一个联系人
    More50MFile: 'The file exceeds 50M and cannot be uploaded', // 文件超过50M, 无法上传
    NetworkErrorTryAgain: 'Network error, please try again', // 网络异常，请重试
    TimeUnavailable: 'Start time cannot be later than end time', // 开始时间不能晚于结束时间
    TimeUnavailableOfLessthan: 'Start time cannot be less than current time', // 开始时间不能早于当前时间
    CollaboratorsFullNotJoin: 'The number of collaborators is full and cannot join, please contact the inviter', // 协作人数已满，无法加入，请联系邀请人
    AddFriendSucc: 'Request to add friend application successful', // 请求添加好友申请成功
    ConfirmHasMember: 'Please select invite members to confirm', // 请选择邀请成员后确定
    Less2CharOfName: 'Name at least 2 characters', // 姓名至少2个字符
    ResolvingInviteLink: 'Resolving invite link', // 正在解析邀请链接
    NotOperateOfLogout: 'User is logged out and cannot operate', // 用户已注销，无法操作
    UnknownMistake: 'unknown mistake', // 未知错误
  },
  calling: {
    Camera: 'Camera', // 摄像头
    Microphone: 'Microphone', // 麦克风
    Speaker: 'Speaker', // 扬声器
    Sticker: 'Sticker', // 万事贴
    Arrow: 'Arrow', // 箭头
    Color: 'Color', // 颜色
    Revoke: 'Revoke', // 撤销
    StickerImage: 'Sticker Image', // 贴图
    LaserPointer: 'Laser Pointer', // 激光笔
    FreezeScreen: 'Freeze screen', // 冻屏
    WhiteBoard: 'White board', // 白板
    Size: 'Size', // 大小
    FreezingOf: 'XX is freezing', // XX正在冻屏中
    WhiteBoardOf: 'XX is whiteboarding', // XX正在白板中
    ScreenShare: 'Screen Share', // 屏幕共享
    Members: 'Members', // 成员
    Annotator: 'Annotator', // 标注者
    GrantAnnotationPermissions: 'Grant annotation permissions', // 授予标注权限
    More: 'More', // 更多
    CloseVideo: 'Close video', // 关闭视频
    DesignatedHost: 'Designated host', // 指定主持人
    Remove: 'Remove', // 移除
    designateHostOf: 'You designate XX as the host', // 你指定XX为主持人
    designatedHostOfMe: 'You have been designated as the host', // 你已被指定为主持人
    grantedAnnotationPermissionOfMe: 'You have been granted annotation permission', // 你已被授予标注权限
    rejectsAnnotationPermission: 'The host rejects your request for annotation permission', // 主持人拒绝标注权限申请
    revokedAnnotationPermission: 'Your annotation permission has been revoked', // 你的标注权限被取消
    FreezeScreenSaved: 'Freeze screen saved', // 冻屏已保存
    WhiteBoardScreenSaved: 'WhiteBoard screen saved', // 白板已保存
    InvitationLinkCopied: 'Invitation link copied', // 邀请链接已复制
    GrantingAnnotationPermissionSucc: 'Granting annotation permission succeeded', // 授予标注权限成功
    CancelAnnotationPermissionSucc: 'Cancel annotation permission successfully', // 取消标注权限成功
    GrantingAnnotationPermission: 'Allow annotation', // 授予标注权限
    CancelAnnotationPermission: 'Cancel annotation permission', // 取消标注权限
    ApplyLabelingPermission: 'The labeling function requires authorization to use. Do you need to apply for permission?', // 标注功能需要授权才能使用，是否申请权限？
    AppliesLabelingPermissionOf: 'XX applies for labeling permission', // XX申请标注权限
    TurnOnScreenSharingException: 'Turn on screen sharing exception', // 开启屏幕共享异常
    PleaseCheckSystemAuth: 'For MAC systems, please check the security and privacy settings of the system settings for screen sharing permissions. For Windows system, please select the corresponding window to share', // MAC系统请检查系统设置的安全与隐私设置屏幕共享权限。Windows系统请选择相应的窗口进行共享
    GotIt: 'Got it', // 知道了
    sharingScreen: 'hileia-web.hiarcloud.com is sharing your screen', // hileia-web.hiarcloud.com正在共享您的屏幕。
    StopSharing: 'Stop sharing', // 停止共享
    Hide: 'Hide', // 隐藏
    EndCollaboration: 'End collaboration', // 结束协作
    LeaveCollaborationToast: 'Leave the collaboration: just hang up by yourself, the system will assign a new moderator', // 离开协作：仅自己挂断，系统会指定新的主持人
    EndCollaborationToast: 'End collaboration: all personnel will be hung up', // 结束协作：所有人员将被挂断
    LeaveCollaboration: 'Leave collaboration', // 离开协作
    Mute: 'Mute', // 静音
    CameraAndShareNotUseOnSameTime: 'Screen sharing and webcam video cannot be used at the same time', // 屏幕共享和摄像头视频无法同时使用
    TurnoffCameraAndOnShare: 'Whether to turn off the camera and turn on screen sharing', // 是否关闭摄像头并开启屏幕共享
    TurnoffShareAndOnCamera: 'Whether to turn off screen sharing and turn on the camera', // 是否关闭屏幕共享并开启摄像头
    SureShare: 'When the screen is shared, the collaborating parties in the call will see any of your actions. Are you sure to share?', // 屏幕共享时，通话中协作方将看到您的任意操作，确认进行共享？
    HungUpOfLeaveCollaboration: 'Leave the collaboration, the collaboration will be hung up', // 离开协作，协作将被挂断
    SureLeave: 'Are you sure to leave?', // 确定离开
    RTCRoomAbnormal: 'Entering the RTC room is abnormal', // 进入RTC房间异常
    MicrophoneAbnormal: 'Microphone not functioning properly', // 麦克风功能异常
    CameraAbnormal: 'Camera not functioning properly', // 摄像头功能异常
    RefreshPage: 'Please refresh the current page to avoid problems with the audio and video communication function. Please make sure that the microphone, camera and screen recording permissions of the system and browser are in the "Allow" state, otherwise the communication function will be abnormal.', // 请刷新当前页面，避免音视频通讯功能出现问题。请务必保证系统和浏览器的麦克风、摄像头以及屏幕录制的权限为"允许"状态，否则会导致通讯功能异常。
    ObtainCameraPermissionsFailed: 'Failed to open the camera. Please allow the website to obtain camera permission, or check whether there is a camera device, or check whether the camera is occupied.', // 打开摄像头失败，请允许网站获取摄像头权限，或检查是否有摄像头设备，或者检查摄像头是否被占用。
    ObtainAudioPermissionsFailed: 'Failed to open the audio. Please allow the website to obtain audio permission, or check whether there is a audio device, or check whether the audio is occupied.', // 打开麦克风失败，请允许网站获取麦克风权限，或检查是否有麦克风设备，或者检查麦克风是否被占用
    LaserPointerUsing: 'The current video source has been occupied by the laser pointer function, please turn off the laser pointer function and try again', // 当前视频源已被激光笔功能占用，请关闭激光笔功能后重试
    MoreFunctionNotUseOfSameTime: 'Screen sharing, laser pointer, freeze screen and other functions cannot be used together, please close the functions you are using and try again', // 屏幕共享、激光笔、冻屏等功能无法共同使用，请关闭正在使用的功能后重试
    OtherNotSupportFunction: "The other party's device does not support this function", // 对方设备暂不支持该功能
    WebNotSupportFunction: 'The Web page does not currently support the labeling and whiteboard functions of MasterCard. you can', // 网页端暂时不支持万事贴标注和白板功能。您可以
    DownloadWinClient: 'download the Windows client', // 下载Windows客户端
    Use: 'use', // 使用
    CollaborativeMember: 'Collaborative member', // 协作成员
    CollaborativeFile: 'Collaborative file', // 协作文件
    Call: 'call', // 呼叫
    RemovedMember: 'You have removed“XX”', // 您已移除"XX"
    RemovalFailedTryAgain: 'Removal failed, please try again', // 移除失败，请重试
    CancelAnnotationPermissionFailed: 'Failed to cancel annotation permission, please try again', // 取消标注权限失败，请重试
    GrantAnnotationPermissionFailed: 'Failed to grant callout permission, please try again', // 授予标注权限失败，请重试
    SpecifyHostFailed: 'Failed to specify host, please try again', // 指定主持人失败，请重试
    TurnoffLaserPointerTryAgain: 'The user video source has been occupied by the laser pointer function, please turn off the laser pointer function and try again', // 该用户视频源已被激光笔功能占用，请关闭激光笔功能后重试
    AddMemberFormMember: 'Add collaborators in "Members"', // 可在“成员”中添加协作人员
    EnteringCollaboration: 'Entering into collaboration', // 正在进入协作中
    ScreenSharing: 'Screen sharing', // 屏幕共享中
  },
  addressBook: {
    Contacts: 'Contacts', // 通讯录
    CompanyProfile: 'Company Profile', // 公司介绍
    CompanyAddress: 'Company Address', // 公司地址
    peopleOf: 'X people', // X人
    PhoneNumber: 'Phone number', // 电话
    Phone: 'Phone', // 电话
    Mail: 'Mail', // 邮箱
    NotAddFriendOfExist: 'Added friends cannot be added again', // 已添加好友不可重复添加
  },
  notify: {
    ViewNotifications: 'View all notifications', // 查看全部通知
    FriendNotifications: 'Friend notifications', // 好友通知
    CollaborationNotifications: 'Collaboration notifications', // 协作通知
    SystemNotifications: 'System notifications', // 系统通知
    InvitesQuickCollaborationOf: 'XX invites you to participate in quick collaboration', // XX邀您参加快速协作
  },
  personSetting: {
    PersonalInfo: 'Personal data', // 个人资料
    Name: 'Name', // 姓名
    Company: 'Company', // 公司
    Position: 'Position', // 职位
    AccountSafety: 'Account safety', // 账户安全
    ChangePassword: 'Change the password', // 修改密码
    OldPassword: 'Old Password', // 旧密码
    PleaseEnter: 'Please enter', // 请输入
    PleaseEnterOldPassword: 'Please enter old password', // 请输入旧密码
    NewPassword: 'New Password', // 新密码
    EnterNewPassword: 'Please enter a new password', // 请输入新密码
    ConfirmAgain: 'Please confirm again', // 再次确认
    ConfirmPassword: 'Please confirm your password', // 请确认密码
    GeneralSettings: 'General settings', // 常规设置
    Definition: 'Definition', // 清晰度
    JoinCollaborativeMute: 'Join Collaborative Mute', // 加入协作静音
    SignOut: 'Sign out', // 退出登录
    Approved1: 'Approved', // 已被同意
    Approved2: 'Approved', // 已同意
    InviteParty: 'invite you to participate', // 邀您参加
    Cancelled: 'Cancelled', // 取消了
    Closed: 'Closed', // 关闭了
    BeRemoved: 'You have been removed', // 将你移出
    UploadFileTo: 'Upload attachments to', // 上传附件到
    Update: 'Update', // 更新了
    ApplyLabelAuth: 'Apply Label Permission', // 标注权限申请
    ApplyLabelAuthInfo: 'If enabled, members need to apply to the host to use the laser pointer, sticky notes, freeze screen, and whiteboard graffiti functions during collaboration.', // 若开启，协作时，成员需要向主持人申请才能使用激光笔、万事贴、冻屏、白板涂鸦功能
    About: 'About', // 关于
  },
  rtc: {
    RTCClientNotExist: 'RTC client does not exist', // RTC客户端不存在
    WebOnlySupportRTC: 'The WEB side only supports the sound network RTC engine', // WEB端只支持声网RTC引擎
  },
  mqtt: {
    CollaborationClosed: 'This collaboration is closed', // 本次协作已关闭
    RejectedCollaborationOfNotRTC: 'The RTC type of the current collaboration is not Agora or LeiaRTC, this collaboration has been cancelled', // 当前协作的RTC类型不是声网或LeiaRTC，已取消本次协作
    AccountLoginOfAntherDevice: 'Your account is already logged in on another device or on a new page', // 您的账号已在其他设备或新页面登录
    ReconnectingIMService: 'Reconnecting to IM service', // 正在重新连接IM服务中
    LeaveCollaborationOfDisconnected: 'Disconnected from IM server, has left collaboration.', // 与IM服务器断开，已离开协作。
    AlwaysConnected: 'Always connected? Please click here', // （始终处于连接中？）
    PleaseClickHere: 'Please click here', // 请点击此处
    ServiceConnectionSucc: 'Service connection succeeded!', // 服务连接成功！
    UserInfoInvalid: 'User information is invalid, please log in again', // 用户信息失效，请重新登录
    BeenRemoved: 'You have been removed', // 你已被移除
    OperationFailedTryAgain: 'Operation failed, please try again', // 操作失败，请重试
    InvitesCollaboration: 'XX invites you to participate in remote collaboration', // XX邀请你参加远程协作
    hostHasMutedYou: 'The host has muted you', // 主持人已将您静音
  },
  main: {
    SwitchedOrNotLogin: 'User has switched or is not logged in', // 用户已切换或未登录
    RejoinCollaborationOfDisconnected: 'Internet connection unavailable, please rejoin the collaboration', // 网络连接不可用，请重新加入协作
    InternetUnavailable: 'Internet connection unavailable', // 网络连接不可用
    Refresh: 'refresh', // 刷新
    NetworkRecovery: 'network recovery', // 网络恢复
    RefreshPageAvoidProblems: 'Please refresh the current page to avoid problems with the audio and video communication function.', // 请刷新当前页面，避免音视频通讯功能出现问题。
  },
  global: {
    Member: 'ordinary member', // 普通成员
    Label: 'label', // 标注
    Departed: 'departed', // 已离开
    Timedout: 'timeout', // 已超时
    Offline: 'offline', // 已离线
    OtherBusy: 'Busy', // 对方忙
    Refused: 'Refused', // 已拒绝
  },
  inviteLink: {
    CollaborationCopied: 'Collaboration information has been copied', // 协作信息已复制
    InvitesCollaborateUseHiLeia: 'XX invites you to collaborate with HiLeia', // XX 邀请您使用 HiLeia 参加协作
    CollaborationCopyFailed: 'Collaboration information replication failed', // 协作信息复制失败
  },
  warn: {
    SelectAndContinue: 'Authorization in progress, please select to continue', // 正在进行授权，请选择后再继续操作
    GrantMicrophoneAuthWarning: 'Please grant permission to use the microphone, otherwise the audio call will be abnormal', // 请授予麦克风使用权限，否则音频通话会异常
  },
  logout: {
    Continue: 'Continue', // 继续
    CancelAccount: 'Application to cancel HiLeia account', // 申请注销HiLeia账户
    CanelHiLeiaMessage: 'After canceling your HiLeia account, you will no longer be able to use HiLeia, but the account will still be able to continue to be used if you have registered with other applications of the HiLeia.', // 注销HiLeia账户后，您将无法继续使用HiLeia，但该账号如注册了亮风台其他应用将仍可继续使用。
    BeforeCanelMessage: 'Before canceling, we will conduct the following checks to ensure the security of your account:', // 注销前，我们将会进行如下检查，以保证您的账户安全：
    VerifyIdentity: 'Verify your identity', // 核验您的身份
    AccountValidState: 'Check whether the account is in a valid and compliant state', // 审核账户是否处于有效、合规的状态
    CancelHiLeiaMessage: 'Cancellation of HiLeia account will have the following effects:', // 注销HiLeia账户将会产生如下影响：
    NotLogInAndUseHiLeia: 'Unable to log in and use HiLeia', // 无法登录和使用HiLeia
    NotAccessFriendAndCocData: 'Loss of access to all previous chats, all collaborators and friends in the account', // 无法访问账户内此前的所有聊天记录、所有协作方和好友
    NotAccessHistoryData: "Can't access historical collaborations and related attachments, but your uploaded files will be kept for others to access due to sharing by collaboration members", // 无法访问历史协作及相关的附件，但您上传的文件因协作成员共享将会被保留其他人可以访问
    NotAccessAndSaveARData: 'Unable to access and reproduce saved AR annotation data', // 无法访问和复现保存的AR标注数据
    ReadAndKnow: 'I have read and know', // 我已阅读并知晓
    HiLeiaCancelAgreement: '"HiLeia User Account Cancellation Agreement"', // 《HiLeia用户账户注销协议》
    ConfirmContinue: 'Confirm and continue', // 确认并继续
    LeavingHiLeiaMessage: 'We are very saddened that you are leaving HiLeia. At the same time, I would like to know the reason for your account cancellation, so that we can continuously improve our products and services, and look forward to your use again.', // 您即将离开HiLeia，我们非常不舍。同时想了解您注销账号的原因，以便我们不断地提升产品服务，期待您再次使用。
    SecurityPrivacyIssues: 'Security/Privacy Issues', // 安全/隐私问题
    NotResolveIssues: 'Unable to resolve scene issues', // 无法解决场景问题
    BadExperience: 'Bad product experience', // 产品使用体验差
    ExcessiveCost: 'Excessive cost', // 费用过高
    TallSuggestAndProblem: 'Tell us about your suggestions or problems', // 说说你的建议或遇到的问题
    VerifySended: 'A verification code has been sent to your phone', // 验证码已发送至您的手机号
    ConfirmCancel: 'Confirm account cancellation', // 确认注销账户
    VerifyNotEmpty: 'verification code must be filled', // 验证码不能为空
    IncorrectVerify: 'Incorrect verification code', // 验证码位数不正确
    LogoutSucc: 'Logout succeeded', // 注销成功
    NotProvideService: 'Unfortunately, we cannot continue to provide you with HiLeia services, thank you for your use!', // 很遗憾，亮风台无法继续为您提供HiLeia服务，感谢您的使用！
    Reacquire: 'Reacquire', // 重新获取
    Valid15M: 'Valid for 15 minutes', // 15分钟内有效
  }
}
